"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
/**
 * Reset a user's password
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param userName The username of the user
 */
function resetPassword(baseUrl, wardenToken, userName) {
    return http_client_1.default({
        method: "POST",
        url: baseUrl + "/api/v4/users/" + userName + "/resetPassword",
        headers: {
            Authorization: "Bearer " + wardenToken
        },
        data: {}
    }).then(function (response) { return response.data; });
}
exports.default = resetPassword;
